export default "__VITE_ASSET__8e1d6808__"